
import React from 'react';
import { Input } from '@/components/ui/input';
import { Search } from 'lucide-react';

interface TeacherProfilesSearchProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
}

export const TeacherProfilesSearch: React.FC<TeacherProfilesSearchProps> = ({
  searchQuery,
  onSearchChange,
}) => {
  return (
    <div className="relative">
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
      <Input
        type="text"
        placeholder="ค้นหาด้วยรหัสครู ชื่อ หรือชื่อเล่น..."
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        className="pl-10"
      />
    </div>
  );
};
